<template>
  <div class="device-monitor_col" :class="{ inline: isInline }">
    <el-image :src="url" :preview-src-list="[url]"></el-image>
    <MultiLineText :text="text" :share-out="true" />
  </div>
</template>

<script>
import { getDeviceTypeImg } from '@/utils/deviceUtils/index';

import MultiLineText from '../components/MultiLineText/index';
import { isFunction } from '@/utils/is';

export default {
  components: { MultiLineText },
  props: {
    device: {
      type: Object,
      default: () => ({})
    },
    isInline: {
      type: Boolean,
      default: true
    },
    formatter: {
      type: Function,
      default: () => () => ''
    },
    prop: {
      type: String,
      default: 'deviceTypeName'
    }
  },
  computed: {
    url() {
      return getDeviceTypeImg(this.device.deviceType).picture;
    },
    text() {
      return isFunction(this.formatter) ? this.formatter(this.device) : this.device[this.prop];
    }
  }
};
</script>

<style lang="scss">
.device-monitor_col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;

  &.inline {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }

  .el-image {
    padding: 0 15px;
    .el-image__inner {
      width: max(calc(var(--font-size) * 3), 90px);
      object-fit: contain;
    }
  }

  .multi-line {
    display: flex;
    flex-direction: column;
  }
}
</style>
